/**
 * VidBolt.ai - Navbar scroll state.
 *
 * Deepens the header's frosted glass once content starts passing underneath.
 * At the top of the page there is nothing behind the bar, so it can stay light.
 * Shared by every page, including the legal pages that load no other script.
 */
'use strict';

(() => {
    const nav = document.querySelector('.navbar-container');
    if (!nav) return;

    const THRESHOLD = 12;
    let ticking = false;

    function apply() {
        nav.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
        ticking = false;
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    apply(); // honour a restored scroll position on load
})();
